"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var InvoiceStatus;
(function (InvoiceStatus) {
    InvoiceStatus["all"] = "all";
    InvoiceStatus["open"] = "open";
    InvoiceStatus["past"] = "past";
    InvoiceStatus["allocated"] = "allocated";
    InvoiceStatus["requested"] = "requested";
    InvoiceStatus["received"] = "received";
    InvoiceStatus["paid"] = "paid";
})(InvoiceStatus = exports.InvoiceStatus || (exports.InvoiceStatus = {}));
//# sourceMappingURL=InvoiceStatus.js.map